import {
  HttpInterceptorFn,
} from '@angular/common/http';

import {
  catchError,
  throwError,
} from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (
  req,
  next,
) => {
  if (
    req.url.includes('/assets/') ||
    req.url.includes('/auth/login') ||
    req.url.includes('/auth/signup') ||
    req.url.includes('/auth/refresh') ||
    req.url.includes('/show/app/languages') ||
    req.url.includes('/check/domain/')
  ) {
    return next(req);
  }

  const token =
    localStorage.getItem('@mlUser');

  let authRequest = req;

  if (
    token &&
    req.url.startsWith(
      'https://menuload.com/api',
    )
  ) {
    authRequest = req.clone({
      setHeaders: {
        Authorization:
          `Bearer ${token}`,
      },
      withCredentials: true,
    });
  }

  return next(authRequest).pipe(
    catchError((error) => {
      if (error.status === 401) {
        localStorage.removeItem('@mlUser');
      }

      return throwError(() => error);
    }),
  );
};